import { profile, socials } from '../data/content';
import { SocialIcon } from './primitives';

export function Footer() {
  return (
    <footer className="footer">
      <div className="container footer__inner">
        <p>
          © {new Date().getFullYear()} {profile.name} · Built with React, TypeScript, and Vite ·{' '}
          <a href="https://github.com/palbirmin/palbirmin.github.io" target="_blank" rel="noreferrer">
            Source
          </a>
        </p>

        <ul className="socials">
          {socials.map((social) => (
            <li key={social.id}>
              <a href={social.href} aria-label={social.label} rel="noreferrer">
                <SocialIcon name={social.id} />
              </a>
            </li>
          ))}
        </ul>
      </div>
    </footer>
  );
}
